import React from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import { PublicNavigation } from '../components/PublicNavigation';
import { PublicHeroSection } from '../components/PublicHeroSection';
import { ServiceCategoriesSection } from '../components/ServiceCategoriesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FeaturedCaregiversSection } from '../components/FeaturedCaregiversSection';
import { MembershipBenefitsSection } from '../components/MembershipBenefitsSection';
import { StatsSection } from '../components/StatsSection';
import { CTASection } from '../components/CTASection';
import { PublicFooter } from '../components/PublicFooter';
import { usePublicHome } from '../hooks/usePublicHome';

export const PublicHomePage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { 
    testimonials, 
    featuredCaregivers, 
    stats, 
    loading, 
    error 
  } = usePublicHome();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Public Navigation */}
      <PublicNavigation />
      
      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1 }}>
        {/* Hero Section */}
        <PublicHeroSection />
        
        {/* Service Categories */}
        <ServiceCategoriesSection />
        
        {/* Statistics */}
        <StatsSection stats={stats} loading={loading} />
        
        {/* Featured Caregivers */}
        <FeaturedCaregiversSection 
          caregivers={featuredCaregivers} 
          loading={loading} 
        />
        
        {/* Testimonials */}
        <TestimonialsSection 
          testimonials={testimonials} 
          loading={loading} 
        />
        
        {/* Membership Benefits */}
        <MembershipBenefitsSection />
        
        {/* Call to Action */}
        <CTASection />
      </Box>
      
      {/* Footer */}
      <PublicFooter />
    </Box>
  );
};

export default PublicHomePage;
